// @ts-nocheck ec66af04
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_header'],
      sections: [
        addPanel.sections.getSections().designPanelOnly.headerStyleSection,
      ],
    };
  },
};
